import * as dagpb from '@ipld/dag-pb'
import { Buffer } from 'buffer/'
import { CID } from 'multiformats/cid'
import { sha256 } from 'multiformats/hashes/sha2'

export const cidFromBuffer = async (buffer: Buffer) => {
  const hash = await sha256.digest(buffer)
  return CID.create(1, dagpb.code, hash)
}
